import { Injectable } from '@angular/core';
import { AuthService } from 'app/services/auth.service';
import { StorageService } from 'app/services/database/storage.service';
import { UserRepository } from 'app/services/database/user.repository';
import { Logger } from 'app/shared/logger';
import { LoggerFactory } from 'app/shared/loggerFactory';
import { FileModel } from 'app/views/presentations/models/file.model';
import { FileModelBuilder } from './../views/presentations/models/file.model';

@Injectable()
export class FileService {
    private logger: Logger;

    constructor(loggerFactory: LoggerFactory,
                private userRepository: UserRepository,
                private storageService: StorageService,
                private authService: AuthService
    ) {
        this.logger = loggerFactory.create('FileService');
    }

    public async uploadFile(presentationId: string, sectionId: string, file: FileModelBuilder) {
        let user = await this.authService.getCurrentUser();
        await this.storageService.upload(presentationId, sectionId, file);
        let url = await this.storageService.getDownloadUrl(presentationId, sectionId, file.id);
        return new UploadedFileInfo(url, file.id);
    }

    public async deletePresentationFiles(presentationId: string) {
        try {
            await this.storageService.deletePresentation(presentationId);
            this.logger.debug(`Deleted presentation ${presentationId} from storage.`);
        } catch (err) {
            this.logger.error(err.message);
        }
    }

    public async deleteSectionFiles(presentationId: string, sectionId: string) {
        try {
            await this.storageService.deleteSection(presentationId, sectionId);
            this.logger.debug(`Deleted presentation ${presentationId} section '${sectionId}' from storage.`);
        } catch (err) {
            this.logger.error(err.message);
        }
    }

    public async deleteFile(presentationId: string, sectionId: string, fileId: string) {
        try {
            await this.storageService.deleteFile(presentationId, sectionId, fileId);
            this.logger.debug(`Deleted presentation ${presentationId} section '${sectionId}' file '${fileId}' from storage.`);
        } catch (err) {
            this.logger.error(err.message);
        }
    }
}

export class UploadedFileInfo {
    constructor(public url?: string, public id?: string) { }
}



// WEBPACK FOOTER //
// ./src/app/services/files.service.ts